import { CtaLoginAction, CtaLoginActionValue } from '../components/common/model';

export enum LoginCtaHref {
    LoginStrong = '/mano?source=i',
    LoginAny = '/mano?source=p',
}

/** Mano login href; return after login is handled by BE via Referer, not a redirect query param. */
export const loginCtaHref = (action: CtaLoginActionValue): string =>
    action === CtaLoginAction.LoginStrong ? LoginCtaHref.LoginStrong : LoginCtaHref.LoginAny;
